import {AxiosInstance, AxiosPromise} from 'axios';
import {appURLS} from "appRoot/app.constants";
import {IAccount} from 'app/app.types';
import NetworkRequestsService from 'external-services/network-requests-service/index';

const NS = 'AccountService';

const api: AxiosInstance = NetworkRequestsService.getGlobalAPIWithoutToken();

class AccountService {

  getAccountById(accountId: string): AxiosPromise<IAccount> {
    /**
     * @todo: couldn't get AccountsController.cs version of this working. Should be using that as '/bookings/' is strictly meant for widget
     */
    return api.get(`${appURLS.API}/bookings/accounts/${accountId}`).then(({data}) => data);
  }
}

const instance = new AccountService();
export default instance as AccountService;
